export const REALISATION_FILTERS = [
  "Toutes",
  "Résine décorative",
  "Résine industrielle",
  "Résine pailletée",
  "Béton ciré",
  "Moquette de pierre",
  "Peinture",
];

export const REALISATIONS = [
  {
    id: 113,
    technique: "Peinture",
    espace: "Radiateurs en fonte — décapage & remise à neuf",
    description: "Rénovation de radiateurs en fonte à Pibrac : décapés à la sableuse pour retirer les anciennes couches, puis repeints avec une peinture adaptée — un rendu comme neuf. Réalisation Resineko.",
    image: "/images/chantiers/peinture-radiateurs-fonte.jpg",
    illustration: false,
    slug: "radiateurs-fonte-pibrac",
    pageTitle: "Radiateurs en fonte rénovés à Pibrac",
    ville: "Pibrac",
    serviceSlug: "peinture-batiment",
    photos: ["/images/chantiers/peinture-radiateurs-fonte.jpg"],
    story: [
      "Ce chantier s'est déroulé à Pibrac, où il fallait rénover des radiateurs en fonte et les remettre au propre. Avec leurs anciennes couches de peinture accumulées, une simple couche par-dessus n'aurait pas donné un résultat durable.",
      "Nous avons donc commencé par décaper les radiateurs à la sableuse, pour revenir à une fonte propre et saine — l'étape qui garantit l'accroche et la tenue dans le temps.",
      "Ils ont ensuite été repeints avec une peinture adaptée, appliquée au pistolet pour un rendu tendu et régulier : des radiateurs comme neufs, prêts pour des années.",
    ],
  },
  {
    id: 112,
    technique: "Peinture",
    espace: "Appartement T3 — ratissage à l'enduit & peinture complète",
    description: "Rénovation complète de ce T3 à Blagnac : les murs, très abîmés, ont été rattrapés à l'enduit de ratissage pour des supports parfaitement lisses, puis peinture complète des murs et des plafonds. Réalisation Resineko.",
    image: "/images/chantiers/peinture-blagnac-piece.jpg",
    illustration: false,
    slug: "enduit-peinture-t3-blagnac",
    pageTitle: "Ratissage à l'enduit et peinture complète d'un T3 à Blagnac",
    ville: "Blagnac",
    serviceSlug: "peinture-batiment",
    localSlug: "resine-sol-blagnac",
    photos: [
      "/images/chantiers/peinture-blagnac-sejour-travaux.jpg",
      "/images/chantiers/peinture-blagnac-sejour-2-travaux.jpg",
      "/images/chantiers/peinture-blagnac-piece.jpg",
      "/images/chantiers/peinture-blagnac-couloir.jpg",
    ],
    story: [
      "Ce chantier s'est déroulé à Blagnac, dans un appartement T3 à rénover entièrement. Le point de départ était exigeant : les murs étaient très abîmés, et peindre par-dessus aurait simplement masqué les défauts pour quelques mois.",
      "Nous avons donc commencé par rattraper tous les défauts des murs à l'enduit de ratissage, jusqu'à obtenir des supports bien lisses — la condition d'une belle finition. Ce travail de préparation, invisible sur les photos finales, est pourtant ce qui fait la durabilité du résultat.",
      "Nous avons ensuite réalisé la peinture complète de l'appartement, murs et plafonds : un rendu net et lumineux, du séjour au couloir, prêt à accueillir ses occupants.",
    ],
  },
  {
    id: 110,
    technique: "Peinture",
    espace: "Appartement — pièces de vie et chambres",
    description: "Peinture intérieure complète de cet appartement à Toulouse : teintes blanc cassé et taupe chaud, mur d'accent vert profond dans la chambre, plafonds blancs. Réalisation Resineko.",
    image: "/images/chantiers/peinture-toulouse-chambre-verte.jpg",
    illustration: false,
    slug: "peinture-appartement-toulouse",
    pageTitle: "Peinture complète d'un appartement à Toulouse",
    ville: "Toulouse",
    serviceSlug: "peinture-batiment",
    localSlug: "peinture-toulouse",
    photos: [
      "/images/chantiers/peinture-toulouse-entree-travaux.jpg",
      "/images/chantiers/peinture-toulouse-chambre-travaux.jpg",
      "/images/chantiers/peinture-toulouse-chambre-verte.jpg",
      "/images/chantiers/peinture-toulouse-sejour.jpg",
      "/images/chantiers/peinture-toulouse-sejour-2.jpg",
    ],
    story: [
      "Ce chantier s'est déroulé à Toulouse, dans un appartement dont les propriétaires souhaitaient une rénovation complète des peintures intérieures : pièces de vie, circulations et chambres.",
      "Après préparation des supports, nous avons appliqué une palette sobre et lumineuse — blanc cassé et taupe chaud sur les murs, plafonds en blanc pur — avec un mur d'accent vert profond dans la chambre, qui donne du caractère à la pièce sans l'assombrir.",
      "Les photos montrent le chantier en cours puis les pièces terminées : lignes d'angle nettes, raccords soignés et finitions propres.",
    ],
  },
  {
    id: 111,
    technique: "Peinture",
    espace: "Appartement — ratissage à l'enduit & rénovation complète des murs",
    description: "Les murs de cet appartement à Colomiers étaient très abîmés : nous avons ratissé tous les murs à l'enduit avant de repeindre l'ensemble du logement — séjour, cuisine, chambres. Réalisation Resineko.",
    image: "/images/chantiers/peinture-colomiers-sejour-baies.jpg",
    illustration: false,
    slug: "enduit-peinture-appartement-colomiers",
    pageTitle: "Murs ratissés à l'enduit puis repeints — appartement à Colomiers",
    ville: "Colomiers",
    serviceSlug: "peinture-batiment",
    localSlug: "resine-sol-colomiers",
    photos: [
      "/images/chantiers/peinture-colomiers-enduit-travaux.jpg",
      "/images/chantiers/peinture-colomiers-sejour-baies.jpg",
      "/images/chantiers/peinture-colomiers-sejour-escalier.jpg",
      "/images/chantiers/peinture-colomiers-cuisine.jpg",
      "/images/chantiers/peinture-colomiers-chambre.jpg",
    ],
    story: [
      "Ce chantier s'est déroulé à Colomiers, dans un appartement dont les murs étaient vraiment abîmés : fissures, trous et anciennes couches fatiguées. Une simple couche de peinture n'aurait rien arrangé — les défauts auraient resurgi en quelques mois.",
      "Nous avons donc ratissé tous les murs à l'enduit, du séjour aux chambres, pour retrouver des supports parfaitement plans avant de peindre. C'est cette étape invisible — la préparation — qui fait la différence entre une peinture qui tient et une peinture qui cloquent.",
      "Les photos montrent le séjour pendant les travaux — l'enduit frais sur la passe-plat — puis l'appartement terminé : murs lisses et lumineux dans tout le logement.",
    ],
  },
  {
    id: 101,
    technique: "Résine industrielle",
    espace: "Entrepôt de grande hauteur",
    description: "Sol en résine époxy gris clair à finition brillante pour cet entrepôt de Bordeaux, après ponçage du béton quartzé et primaire avec saupoudrage de quartz. Réalisation Resineko.",
    image: "/images/chantiers/entrepot-resine-industrielle.jpg",
    illustration: false,
    slug: "resine-epoxy-entrepot-bordeaux",
    pageTitle: "Sol en résine époxy pour un entrepôt à Bordeaux",
    ville: "Bordeaux",
    serviceSlug: "resine-industrielle",
    localSlug: "resine-sol-bordeaux",
    story: [
      "Ce chantier s'est déroulé à Bordeaux, dans un entrepôt dont le sol en béton quartzé nécessitait une réfection complète. Le client recherchait un sol en résine époxy durable et facile à entretenir.",
      "La préparation a débuté par un ponçage du béton quartzé — étape invisible mais décisive pour l'accroche du système. Nous avons ensuite appliqué un primaire avec saupoudrage de quartz, qui crée la surface d'accrochage idéale, avant l'application de la résine époxy gris clair à finition brillante.",
      "Le résultat : un sol d'entrepôt net, résistant et lumineux, conçu pour supporter l'activité quotidienne.",
    ],
  },
  {
    id: 102,
    technique: "Béton ciré",
    espace: "Salon contemporain",
    description: "Sol en béton ciré gris perle, sans aucun joint, pour ce salon de Montpellier ouvert sur l'extérieur par de grandes baies vitrées. Réalisation Resineko.",
    image: "/images/chantiers/salon-beton-cire.jpg",
    illustration: false,
    slug: "beton-cire-salon-montpellier",
    pageTitle: "Béton ciré sans joint pour un salon à Montpellier",
    ville: "Montpellier",
    serviceSlug: "beton-cire",
    localSlug: "resine-sol-montpellier",
    story: [
      "À Montpellier, ce client avait une exigence claire : un sol sans joint, une surface continue sans la moindre interruption visuelle. Après échange sur ses envies, nous lui avons proposé le béton ciré — la réponse exacte à sa demande.",
      "Le sol de cette pièce de vie, ouverte sur l'extérieur par de grandes baies vitrées, a été habillé d'un béton ciré gris perle dont les nuances discrètes jouent avec la lumière naturelle du matin au soir.",
      "Un intérieur contemporain, sans un seul joint, qui donne au salon une profondeur et une élégance nouvelles.",
    ],
  },
  {
    id: 103,
    technique: "Résine décorative",
    espace: "Résine époxy métallique",
    description: "Sol en résine époxy métallique à effet marbré blanc et gris, reflets nacrés, finition miroir — 65 m² à Bordeaux. Réalisation Resineko.",
    image: "/images/chantiers/resine-epoxy-metalique.jpg",
    illustration: false,
    slug: "resine-epoxy-metallique-bordeaux",
    pageTitle: "Résine époxy métallique effet marbré à Bordeaux — 65 m²",
    ville: "Bordeaux",
    surface: "65 m²",
    serviceSlug: "resine-decorative",
    localSlug: "resine-sol-bordeaux",
    story: [
      "Direction Bordeaux pour ce projet de 65 m² : le client souhaitait un sol en résine époxy métallique à effet marbré — un revêtement décoratif haut de gamme dont chaque réalisation est unique.",
      "Nous avons appliqué une résine époxy métallique au marbrage blanc et gris, aux reflets nacrés, avec une finition miroir. L'effet de profondeur évolue selon la lumière et l'angle de vue.",
      "Sur 65 m², la continuité parfaite de la résine — sans le moindre joint — donne à l'ensemble une allure remarquable.",
    ],
  },
  {
    id: 106,
    technique: "Moquette de pierre",
    espace: "Terrasse piscine",
    description: "Terrasse et pourtour de piscine entièrement repris en moquette de pierre à Nice, teinte claire en accord avec la maison en pierre. Réalisation Resineko.",
    image: "/images/chantiers/piscine-moquette-pierre.jpg",
    illustration: false,
    slug: "moquette-pierre-terrasse-piscine-nice",
    pageTitle: "Rénovation d'une terrasse et plage de piscine en moquette de pierre à Nice",
    ville: "Nice",
    serviceSlug: "moquette-de-pierre",
    localSlug: "resine-sol-nice",
    story: [
      "À Nice, la terrasse de ce client était abîmée par les années et le climat méditerranéen. Il souhaitait la rénover durablement avec de la moquette de pierre.",
      "Nous avons tout repris : préparation complète et soignée du support — la condition invisible de la durabilité — puis application de la moquette de pierre dans une teinte claire, en accord avec la maison en pierre.",
      "La terrasse et le pourtour de piscine ont retrouvé une seconde jeunesse : un revêtement minéral confortable pieds nus, idéal pour les extérieurs du Sud.",
    ],
  },
  {
    id: 107,
    technique: "Peinture",
    espace: "Peinture intérieure",
    description: "Peinture complète d'une maison neuve à Toulouse : murs gris minéral, plafonds et boiseries soignés, de l'entrée à l'escalier. Réalisation Resineko.",
    image: "/images/chantiers/peinture-interieure.jpg",
    illustration: false,
    slug: "peinture-maison-neuve-toulouse",
    pageTitle: "Peinture complète d'une maison neuve à Toulouse",
    ville: "Toulouse",
    serviceSlug: "peinture-batiment",
    localSlug: "resine-sol-toulouse",
    story: [
      "À Toulouse, nous avons réalisé la peinture complète de cette maison neuve : l'ensemble des pièces, de l'entrée à l'escalier.",
      "Les murs ont reçu un gris minéral contemporain, tandis que plafonds et boiseries ont été traités avec la même exigence de finition.",
      "Une maison neuve livrée avec des finitions propres et nettes, prête à vivre.",
    ],
  },
  {
    id: 108,
    technique: "Résine pailletée",
    espace: "Garage",
    description: "Garage de 35 m² rénové en résine pailletée à densité totale à Montauban, pour un sol très résistant aux reflets argentés. Réalisation Resineko.",
    image: "/images/chantiers/garage-resine-pailletee.jpg",
    illustration: false,
    slug: "resine-pailletee-garage-montauban",
    pageTitle: "Garage rénové en résine pailletée à Montauban — 35 m²",
    ville: "Montauban",
    surface: "35 m²",
    serviceSlug: "resine-pailletee",
    localSlug: "resine-sol-montauban",
    story: [
      "À Montauban, ce garage de 35 m² avait besoin d'un sol à la hauteur de son usage : le client voulait avant tout un sol très résistant.",
      "Nous avons rénové le sol avec une résine pailletée à densité totale — les paillettes couvrent l'intégralité de la surface — avec une finition brillante aux reflets argentés.",
      "Résultat : un garage transformé en véritable showroom, avec un sol qui résiste aux chocs, aux taches et au temps.",
    ],
  },
  {
    id: 109,
    technique: "Béton ciré",
    espace: "Escalier intérieur",
    description: "95 m² de carrelage recouverts de béton ciré sans démolition à Toulouse, escalier habillé en continuité parfaite avec le palier. Réalisation Resineko.",
    image: "/images/chantiers/escalier-beton-cire.jpg",
    illustration: false,
    slug: "beton-cire-sur-carrelage-toulouse",
    pageTitle: "Béton ciré sur carrelage sans démolition à Toulouse — 95 m²",
    ville: "Toulouse",
    surface: "95 m²",
    serviceSlug: "beton-cire",
    localSlug: "resine-sol-toulouse",
    story: [
      "À Toulouse, ce projet de 95 m² partait d'un constat fréquent : un sol en carrelage vieilli, que le client ne voulait pas démolir.",
      "Nous avons préparé le carrelage en le ponçant, puis appliqué les primaires adaptés à ce support spécifique, avant d'appliquer le béton ciré clair. L'escalier a été habillé de la même matière, en continuité parfaite avec le palier.",
      "95 m² rénovés sans démolition : un sol minéral continu, sans joint, qui a métamorphosé l'intérieur.",
    ],
  },
  {
    id: 104,
    technique: "Résine décorative",
    espace: "Résine polyuréthane",
    description: "Maison à Quint-Fonsegrives : sol en résine polyuréthane ivoire, finition brillante miroir, en continuité parfaite avec l'escalier et les baies vitrées. Réalisation Resineko.",
    image: "/images/chantiers/resine-epoxy-unie.jpg",
    illustration: false,
    slug: "resine-polyurethane-maison-quint-fonsegrives",
    ville: "Quint-Fonsegrives",
    pageTitle: "Sol en résine polyuréthane brillante pour une maison à Quint-Fonsegrives",
    serviceSlug: "resine-decorative",
    localSlug: "resine-sol-toulouse",
    photos: [
      "/images/chantiers/resine-epoxy-unie.jpg",
      "/images/chantiers/resine-polyurethane-unie.jpg",
    ],
    story: [
      "À Quint-Fonsegrives, à l'est de Toulouse, cette maison a reçu un sol en résine polyuréthane sur l'ensemble de sa pièce de vie — un chantier mené pour un particulier.",
      "La résine a été appliquée dans une teinte claire, couleur ivoire, avec une finition brillante miroir qui capte la lumière des grandes baies vitrées. L'escalier a été traité dans la même continuité, pour un ensemble parfaitement homogène.",
      "Le résultat : un espace de vie lumineux et sans joint, où le sol reflète la lumière naturelle du matin au soir.",
    ],
  },
  {
    id: 105,
    technique: "Résine décorative",
    espace: "Garage professionnel avec logo",
    description: "Garage professionnel près de Lausanne (Suisse) : sol en résine époxy métallique anthracite avec le logo de l'enseigne intégré sous la finition. Réalisation Resineko.",
    image: "/images/chantiers/commerce-logo-resine.jpg",
    illustration: false,
    slug: "resine-epoxy-logo-garage-lausanne",
    ville: "Lausanne (CH)",
    pageTitle: "Sol en résine époxy avec logo intégré pour un garage professionnel à Lausanne",
    serviceSlug: "resine-decorative",
    localSlug: null,
    story: [
      "Ce chantier nous a menés en Suisse, du côté de Lausanne, dans un garage professionnel. Le client souhaitait un sol en résine époxy à la hauteur de son image — avec le logo de son enseigne intégré directement dans le sol.",
      "Nous avons réalisé un sol en résine époxy à effet métallique anthracite, puis intégré le logo de l'enseigne sous la couche de finition : il est ainsi protégé du passage et insensible à l'usure.",
      "Un chantier qui le démontre : notre exigence ne connaît pas les frontières. Nous organisons nos déplacements bien au-delà de la France quand le projet le mérite.",
    ],
  },
  {
    id: 110,
    technique: "Résine décorative",
    espace: "Effet marbré cuivre",
    description: "Sol en résine époxy métallique aux marbrures personnalisées — veines cuivrées et turquoise sur fond bronze — pour ce particulier du Bassin d'Arcachon, 65 m². Réalisation Resineko.",
    image: "/images/chantiers/resine-decorative-marbree.jpg",
    illustration: false,
    slug: "resine-epoxy-marbre-bassin-arcachon",
    ville: "Bassin d'Arcachon",
    surface: "65 m²",
    pageTitle: "Résine époxy métallique sur mesure au Bassin d'Arcachon — 65 m²",
    serviceSlug: "resine-decorative",
    localSlug: "resine-sol-bordeaux",
    story: [
      "Sur le Bassin d'Arcachon, ce particulier souhaitait un sol en résine époxy métallique avec des marbrures composées selon ses envies — un projet de 65 m² entièrement personnalisé.",
      "Nous avons travaillé une résine époxy métallique aux veines cuivrées et turquoise sur fond bronze : chaque marbrure a été dessinée à la main, selon les souhaits du client, pour un rendu qui n'existe nulle part ailleurs.",
      "Dès l'entrée, les 65 m² offrent un effet spectaculaire : un sol miroir dont les reflets évoluent avec la lumière.",
    ],
  },
  {
    id: 111,
    technique: "Résine décorative",
    espace: "Résine époxy métallique or",
    description: "Maison de 83 m² en rénovation à Colomiers : résine époxy métallique aux marbrures dorées, un rendu unique aux reflets changeants. Réalisation Resineko.",
    image: "/images/chantiers/resine-metalique-cuisine.jpg",
    illustration: false,
    slug: "resine-epoxy-metallique-or-colomiers",
    ville: "Colomiers",
    surface: "83 m²",
    pageTitle: "Résine époxy métallique aux effets dorés pour une maison à Colomiers — 83 m²",
    serviceSlug: "resine-decorative",
    localSlug: "resine-sol-colomiers",
    story: [
      "À Colomiers, cette maison de 83 m² était en cours de rénovation. Le client souhaitait un sol en résine époxy métallique avec des effets dorés — un rendu haut de gamme qu'aucun autre revêtement ne peut reproduire.",
      "Nous avons appliqué une résine époxy métallique travaillée pour dessiner des marbrures or, aux reflets changeants selon la lumière. Chaque passage dessine un motif qui n'existera nulle part ailleurs : c'est la signature de cette technique.",
      "Sur les 83 m² de la maison, le sol est devenu la pièce maîtresse de la rénovation : continu, sans joint, et d'une profondeur remarquable.",
    ],
  },
  {
    id: 112,
    technique: "Résine industrielle",
    espace: "Centre de contrôle technique",
    description: "Centre de contrôle technique de 360 m² à Léguevin : sol refait en résine époxy très résistante et facile à nettoyer, zone d'équipement signalée en rouge. Réalisation Resineko.",
    image: "/images/chantiers/garage-resine-industrielle.jpg",
    illustration: false,
    slug: "resine-epoxy-controle-technique-leguevin",
    ville: "Léguevin",
    surface: "360 m²",
    pageTitle: "Sol en résine époxy pour un centre de contrôle technique à Léguevin — 360 m²",
    serviceSlug: "resine-industrielle",
    localSlug: "resine-sol-daux",
    story: [
      "À Léguevin, ce centre de contrôle technique de 360 m² avait un problème concret : un sol devenu difficile à nettoyer. Quand les roues des véhicules tournent et chauffent, la gomme des pneus restait incrustée dans le sol.",
      "Nous avons refait l'intégralité du sol en résine époxy — un revêtement très résistant et facile à nettoyer, précisément adapté à cette contrainte. La zone des équipements de contrôle a été signalée en rouge, pour un poste de travail clair et lisible.",
      "Résultat : 360 m² de sol professionnel qui se nettoie sans effort et résiste au passage quotidien des véhicules.",
    ],
  },
  {
    id: 114,
    technique: "Résine décorative",
    espace: "Salle de bain métallique",
    description: "Appartement de 78 m² à Blagnac : le client voulait un sol sans joint — la salle de bain a reçu une résine époxy métallique anthracite et argent, finition miroir. Réalisation Resineko.",
    image: "/images/chantiers/sdb-resine-metalique.jpg",
    illustration: false,
    slug: "resine-epoxy-salle-de-bain-blagnac",
    ville: "Blagnac",
    pageTitle: "Salle de bain en résine époxy métallique à Blagnac — un sol sans joint",
    serviceSlug: "resine-decorative",
    localSlug: "resine-sol-blagnac",
    story: [
      "À Blagnac, le propriétaire de cet appartement de 78 m² avait une envie précise : un sol sans joint. Séduit par le rendu de la résine époxy métallique, il nous a confié la réalisation.",
      "Dans la salle de bain, nous avons appliqué une résine époxy métallique au marbrage anthracite et argent, avec une finition miroir qui amplifie la profondeur de la pièce.",
      "Un sol continu, sans le moindre joint, facile à entretenir et spectaculaire — exactement ce que le client avait imaginé.",
    ],
  },
];
